const getLineItemAvailability = (availability) => {
  if (!availability?.channels) {
    return void 0;
  }
  const channels = availability.channels.reduce((accumulator, currentValue) => {
    return {
      ...accumulator,
      [currentValue.key]: {
        isOnStock: currentValue.value.isOnStock,
        availableQuantity: currentValue.value.availableQuantity
      }
    };
  }, {});
  return { channels };
};
export {
  getLineItemAvailability
};
//# sourceMappingURL=get-line-item-availability.js.map
